/**
 * Report a caught error to Bugsnag with a context label and structured metadata, so risky
 * operations (content migrations, layout/theme changes) surface in production with enough
 * detail to debug — not just a bare stack from the global handler. Never throws.
 */
export function reportError(context: string, error: unknown, metadata: Record<string, unknown> = {}): void {
  console.error(`[${context}]`, error)

  try {
    window.Bugsnag?.notify(
      error instanceof Error ? error : new Error(String(error)),
      (event: { addMetadata: (section: string, data: Record<string, unknown>) => void }) => {
        event.addMetadata('context', { context, ...metadata })
      },
    )
  } catch {
    // Never re-throw from the reporter.
  }
}
